import { useQuery } from '@apollo/client';
import { GET_FINANCE_PROGRAMS } from '../api';
import { groupBy } from 'utils/arrayUtils';
import { FinanceProgram, LenderProfile } from '@trnsact/trnsact-shared-types';
import { GET_LENDER_PROFILES_WITH_OCA_ACCESS } from 'queries/common';

export function useRelatedOcaLinksDataFetch(accountId: string): {
  lenderProfilesWithOcaAccess: LenderProfile[];
  financeProgramsByLenderProfileId: Record<string, FinanceProgram[]>;
  isLoading: boolean;
} {
  const { data: financeProgramsData, loading: isFinanceProgramsLoading } = useQuery(GET_FINANCE_PROGRAMS, {
    variables: { accountId },
  });

  const { data: lenderProfilesWithOcaAccessData, loading: isLenderProfilesWithOcaAccessLoading } = useQuery(
    GET_LENDER_PROFILES_WITH_OCA_ACCESS,
    {
      variables: { accountId },
    }
  );

  return {
    lenderProfilesWithOcaAccess: lenderProfilesWithOcaAccessData?.lenderProfilesWithOcaAccess?.data,
    financeProgramsByLenderProfileId: groupBy(
      financeProgramsData?.financePrograms,
      'financeProgramToLenderProfiles.0.lenderProfileId'
    ),
    isLoading: isFinanceProgramsLoading || isLenderProfilesWithOcaAccessLoading,
  };
}
